import React, { useMemo } from "react";
import { groupCrossCompanyDuplicates } from "../../../utils/productionDuplicateUtils";
import { ProductionCatalogLoader } from "./ProductionCatalogLoader";

export function ProductionDuplicatesTab({ catalogRows, onCatalogLoaded, companyNames }) {
  const groups = useMemo(
    () => groupCrossCompanyDuplicates(catalogRows ?? []),
    [catalogRows],
  );

  return (
    <section className="card cc-v4-soft-list-root admin-panel-section production-audit-section">
      <ProductionCatalogLoader
        onLoaded={onCatalogLoaded}
        autoLoad
        loadedCount={catalogRows?.length ?? 0}
      />

      {catalogRows?.length ? (
        <>
          <p className="production-audit-muted">
            Групп с дублями между компаниями: {groups.length}
          </p>
          <div className="production-audit-duplicate-list">
            {groups.length === 0 ? (
              <p>Дублей между разными компаниями не найдено.</p>
            ) : (
              groups.map((group) => (
                <article
                  key={group.key}
                  className="production-audit-duplicate-group card"
                >
                  <header className="production-audit-duplicate-header">
                    <strong>{group.displayName || "—"}</strong>
                    <span className="production-audit-muted">
                      {group.displayAddress || "—"}
                    </span>
                    <span className="production-audit-badge">
                      {group.companyCount} компаний · {group.recordCount} записей
                    </span>
                  </header>
                  <div className="cc-v4-soft-grid production-audit-duplicate-grid">
                    <span className="cc-v4-soft-th-static">ID площадки</span>
                    <span className="cc-v4-soft-th-static">ID компании</span>
                    <span className="cc-v4-soft-th-static">Компания</span>
                    {group.rows.map((row) => (
                      <React.Fragment key={`${row.id}-${row.company_id}`}>
                        <span className="admin-users-cell">{row.id}</span>
                        <span className="admin-users-cell">{row.company_id}</span>
                        <span className="admin-users-cell">
                          {companyNames.get(Number(row.company_id)) ??
                            `ID ${row.company_id}`}
                        </span>
                      </React.Fragment>
                    ))}
                  </div>
                </article>
              ))
            )}
          </div>
        </>
      ) : null}
    </section>
  );
}
